import React from "react";
import { Routes, Route } from "react-router-dom";
import ListOrganizations from "./ListOrganizations";
import OrganizationDetail from "./OrganizationDetail";
import AddMembers from "./AddMembers";
import { Header } from "semantic-ui-react";

function Groups() {
return (
    <>
        <Header as="h2" style={{ marginTop: "50px" }}>
            <a href="/" style={{ color: "inherit", textDecoration: "none" }}>
                Organization Groups
            </a>
            <Header.Subheader>
                Browse organizations and view employees in each group.
            </Header.Subheader>
        </Header>
        <Routes>
            <Route path="/" element={<ListOrganizations />} />
            <Route path="organization/:id/employees" element={<OrganizationDetail />} />
            <Route path="organization/:id/add-members" element={<AddMembers />} />
        </Routes>
    </>
);
}

export default Groups;
